import { render, staticRenderFns } from "./QuitDeveloperView.vue?vue&type=template&id=58f4336e&scoped=true&"
import script from "./QuitDeveloperView.vue?vue&type=script&lang=ts&"
export * from "./QuitDeveloperView.vue?vue&type=script&lang=ts&"
import style0 from "./QuitDeveloperView.vue?vue&type=style&index=0&id=58f4336e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f4336e",
  null
  
)

export default component.exports